<div id="addressContainer">

  <div id="shippingAddress" class="subBlockContainer">
    <div class="subBlockContent">
      <child-header [title]="title" (closeEvent)="close()"></child-header>
      <div *ngIf="loadContent" class="child-body">

        <div class="inner-subBlock-wrapper">
          <!-- <div class="page-title-wrapper">
            <div class="title blade-title-font">
              {{title}}
            </div>
            <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
          </div> -->

          <!-- Form elements -->
          <div [formGroup]="addressFormGroup">
            <div class="collect-order">
              <div class="checkbox-center" *ngIf="checkoutViewModel">
                <mat-slide-toggle formControlName="collectTheOrder" (click)="collectOrder()">
                  <span class="collect-font">I will collect </span>
                </mat-slide-toggle>
              </div>
            </div>
            <div class="form-container mt-2" *ngIf="collect">
              <div class="listpart select-out-wrapper">
                <ng-select [items]="locations" bindValue="value" class="shippingValidate" bindLabel="name"
                  placeholder="Delivery / Pick Up" (change)="changeDeliveryMethod($event)"
                  formControlName="deliveryType" [formControl]="shippingMethodControl" required>
                </ng-select>
              </div>
              <p *ngIf="addressFormGroup?.value?.deliveryType !== 'delivery' && addressFormGroup?.value?.deliveryType !== null && addressFormGroup?.value?.deliveryType !== ''">
                {{selectedWarehouse?.out_whse_address01}}, {{selectedWarehouse?.out_whse_address04}}, {{selectedWarehouse?.out_whse_state}}, {{selectedWarehouse?.out_whse_postcode}}
              </p>

              <p>Please provide contact details so we can let you know when your order has been picked and packed and is
                ready for collection.</p>

              <div class="validateAnyOne">
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="emailValidate" type="email" formControlName="email" placeholder="email"
                    required>
                </mat-form-field>

                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="phoneValidate" type="text" formControlName="phone"
                    (keypress)="isNumberKey($event)" placeholder="Phone" required>
                </mat-form-field>
              </div>
            </div>
            <div class="top-divider"></div>
            <div class="form-container" *ngIf="!collect" [@enterAnimation]>
              <div class="shipping-title-content">
                <a id="shipaddressdropdown" (click)="selectLocation()">Select a delivery location from your company’s
                  address book</a>
                <span class="font-color-g3">or add a new one below</span>
              </div>
              <br />
              <div (click)="clearAllFields();"><span class="clearFilterButton">Clear All Fields</span></div>
              <div class="top-divider"></div>
              <div formGroupName="addressGroup" class="address-form">
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="companyNameValidate" formControlName="companyName" placeholder="Company Name"
                    required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="attnOrRefValidate" formControlName="attnOrRef" maxlength="25"
                    placeholder="Attn/Ref*" requried>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput id="addressLine1" class="addressLine1Validate" 
                   formControlName="addressLine1" (change)="omit_nonprintable_char($event)"
                 placeholder="Address Line 1" required>
                </mat-form-field> 
                <mat-form-field [floatLabel]="'always'">
                  <input matInput id="addressLine2" class="addressLine2Validate" formControlName="addressLine2" (change)="omit_nonprintable_char($event)"
                  placeholder="Address Line 2">
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput id="addressLine3" class="addressLine3Validate" formControlName="addressLine3" (change)="omit_nonprintable_char($event)"
                  placeholder="Addiress Line 3">
                </mat-form-field>
                <!-- suburb -->
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger"
                    [matAutocomplete]="autoSuburb" formControlName="suburb" placeholder="Suburb"
                    (keydown.Tab)="chooseAutoCompletSuburb($event)" (input)="onInputSub($event)"
                    (keyup)="startFilterSub()" required>
                  <mat-autocomplete #autoSuburb="matAutocomplete" [displayWith]="displayWithSuburb">
                    <mat-option *ngFor="let option of filteredSubFromAPI" [value]="option"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="addressFormGroup.get('addressGroup.suburb').hasError('required')">
                      Please enter and select a suburb
                  </mat-error>
          
                  <mat-error *ngIf="addressFormGroup.get('addressGroup.suburb').hasError('incorrect')">
                      Please select a valid suburb
                  </mat-error>                 
                </mat-form-field>
                
                <ng-select class="customDropdwon stateValidate" [items]="stateList" bindValue="state" bindLabel="state"
                  placeholder="State *" formControlName="state"></ng-select>
                <!-- post code -->
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="postcodeValidate" maxlength="4"
                    #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (keypress)="isNumberKey($event)"
                    (input)="onInputPostcode($event)" (keyup)="startFilterPostcode()"
                    (keydown.Tab)="chooseAutoCompletPostcode($event)" formControlName="postcode"
                    [matAutocomplete]="autoPostcode" placeholder="Postcode" required>
                  <mat-autocomplete #autoPostcode="matAutocomplete" [displayWith]="displayWithPostcode">
                    <mat-option *ngFor="let option of filteredPostCodeFromAPI" [value]="option"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="addressFormGroup.get('addressGroup.postcode').hasError('required')">
                    Please enter and select a postcode
                  </mat-error>
          
                  <mat-error *ngIf="addressFormGroup.get('addressGroup.postcode').hasError('incorrect')">
                      Please select a valid postcode
                  </mat-error>
                  <mat-error *ngIf="(addressFormGroup.get('addressGroup.postcode')?.invalid && addressFormGroup.get('addressGroup.postcode')?.value?.length > 4)">
                    Please select a valid postcode
                </mat-error>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'">
                  <input matInput class="phoneValidate" formControlName="phone" (keypress)="isNumberKey($event)"
                    placeholder="Phone" required>
                </mat-form-field>
              </div>

              <div class="add-address">
                <mat-checkbox [checked]="addAddressBook" (change)="addToAddressBook($event);"
                  formControlName="addToAddressBook"><span class="checkbox-text">Add to address book</span>
                </mat-checkbox>
              </div>
            </div>
            <div class="part-ship">
              <mat-checkbox (click)="setDispatchDate()" formControlName="partShipTheOrder"><span
                  class="checkbox-text">Part
                  ship this order</span>
              </mat-checkbox>
            </div>

            <div class="shipping-address-dispath" id="desiredDate" *ngIf="currentUserModel.isAU">
              <label for="Desired_Dispatch_Date" class="text-uppercase">
                Desired Dispatch Date:
              </label>

              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dA.toggle()">
                  <img src="../images/new_ui/date.png">
                </div>
                <input class="searchInput date-picker" [(ngModel)]="minDate" type="text" placeholder="Date"
                  mame="shippingDate" ngbDatepicker #dA="ngbDatepicker" (click)="dA.toggle()"
                  formControlName="shippingDate" [minDate]="minDate" [maxDate]="maxDate"
                  (dateSelect)="onDateSelect($event)" readonly>
              </div>

              <P class="light-text">Dicker Data will endeavour to dispatch your order on the selected
                date but cannot guarantee this service.
                Please be advised that delivery may not take place on the same day depending on the courier service
                and
                destination.
              </P>
            </div>
            <div class="checkout-nav" *ngIf="addressRadioButton" [@enterAnimation]>
              <button 
                type="button"
                id="moveToFreight"
                class="button button-red button-large"
                [disabled]="
                  !collect && (addressFormGroup.get('addressGroup.suburb')?.invalid ||
                  addressFormGroup.get('addressGroup.postcode')?.invalid)
                  || hasOutOfStock
                "
                (click)="moveToNext()">Next</button>
              <!-- <div class="bottom-navigation" (click)="backtoCart()">Back to cart</div> -->

              <ng-container [ngSwitch]="backto">
                <div *ngSwitchCase="'renewal'" class="bottom-navigation" (click)="backtoRenewals()">Back to renewals
                </div>
                <div *ngSwitchCase="'quote'" class="bottom-navigation" (click)="backtoQuotes()">Back to quotes
                </div>
                <div *ngSwitchDefault class="bottom-navigation" (click)="backtoCart()">Back to cart</div>
              </ng-container>


              <!-- <ng-container *ngIf="serial;else goRenewals">
              <div class="bottom-navigation" (click)="backtoRenewals()">Back to renewals</div>
            </ng-container>
            <ng-template #goRenewals>
              <div class="bottom-navigation" (click)="backtoCart()">Back to cart</div>
            </ng-template> -->

            </div>
          </div>
        </div>

      </div>
      <loading-screen *ngIf="!loadContent" backDropWidth='350' [showInnerLoading]="true"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>

    </div>


  </div>
  <router-outlet></router-outlet>